import { DropdownWithSearch } from "InnoUI/innoinput";
import { calendarDays } from "utils/optionData/utils";

const CalendarDropdown = ({
  onChange = () => {},
  defaultValue,
  disabled = true,
  name,
  disabledDropdown,
}) => {
  const projectOptions = calendarDays.map((data) => ({
    id: data.id,
    label: data.label,
  }));

  const handleDropdownChange = (value) => {
    const selectedOption = projectOptions.find((option) => option.id === value);
    const selectedLabel = selectedOption ? selectedOption.id : "";
    onChange(name, selectedLabel);
  };

  return (
    <DropdownWithSearch
      defaultValue={defaultValue}
      options={projectOptions}
      onChange={handleDropdownChange}
      borderColor="#ED850C"
      disabled={disabled}
      width="150px"
      dropdowType={name}
      disabledDropdown={disabledDropdown}
    />
  );
};

export default CalendarDropdown;
